import { Subject } from 'rxjs';
import { formPreviewType, formSaveType, fCardSelectionType, fAssetEditType } from './RxServiceTypes';

/**
 * f - forms
 */

const fPreviewsubject = new Subject<formPreviewType>();
const fSavesubject = new Subject<formSaveType>();

const fCardSelection = new Subject<fCardSelectionType>();
const fAssetSelection = new Subject<fAssetEditType>();
const fDeploymentUpdate = new Subject<any>();
const headerData = new Subject<{}>();
const makeDupliacteForm=new Subject<{}>();

const EnvSelection = new Subject<any>();

const ThemeSaveAsnew = new Subject<any>();

const themeReload = new Subject<any>();

const resourceLock = new Subject<any>();

const createMarketplaceFn = new Subject<any>();

const mouseHoverOnTree = new Subject<any>();

export const formPreview = {
    sendMessage: (message: formPreviewType) => fPreviewsubject.next(message),
    clearMessages: () => fPreviewsubject.next(),
    getMessage: () => fPreviewsubject.asObservable()
};

export const formSave = {
    sendMessage: (message: formSaveType) => fSavesubject.next(message),
    clearMessages: () => fSavesubject.next(),
    getMessage: () => fSavesubject.asObservable()
};

export const fAssetEdit = {
    sendMessage: (message: fAssetEditType) => fAssetSelection.next(message),
    clearMessages: () => fAssetSelection.next(),
    getMessage: () => fAssetSelection.asObservable()
}

export const fCardSelect = {
    sendMessage: (message: fCardSelectionType) => fCardSelection.next(message),
    clearMessages: () => fCardSelection.next(),
    getMessage: () => fCardSelection.asObservable()
}

export const DeploymentUpdateVerison = {
    sendMessage: (data: any) => fDeploymentUpdate.next(data),
    clearMessages: () => fDeploymentUpdate.next(),
    getMessage: () => fDeploymentUpdate.asObservable()
}

export const EnvSelect = {
    sendMessage: (data: any) => EnvSelection.next(data),
    clearMessages: () => EnvSelection.next(),
    getMessage: () => EnvSelection.asObservable()
}
export const HeaderData = {
    sendMessage: (message: any) => headerData.next(message),
    clearMessages: () => headerData.next(),
    getMessage: () => headerData.asObservable()
}

export const makeFormDupliacte = {
    sendMessage: (message: any) => makeDupliacteForm.next(message),
    clearMessages: () => makeDupliacteForm.next(),
    getMessage: () => makeDupliacteForm.asObservable()
}

export const RXThemeSaveAsnew = {
    sendMessage: (message: any) => ThemeSaveAsnew.next(message),
    clearMessages: () => ThemeSaveAsnew.next(),
    getMessage: () => ThemeSaveAsnew.asObservable()
}

export const ThemeReload = {
    sendMessage: () => themeReload.next(),
    clearMessages: () => themeReload.next(),
    getMessage: () => themeReload.asObservable()
}

export const ResourceLock = {
    sendMessage: (message: any) => resourceLock.next(message),
    clearMessages: () => resourceLock.next(),
    getMessage: () => resourceLock.asObservable()
}

export const CreateMarketplaceFn = {
  sendMessage: (message: any) => createMarketplaceFn.next(message),
  clearMessages: () => createMarketplaceFn.next(),
  getMessage: () => createMarketplaceFn.asObservable(),
}

export const MouseHoverOnTree = {
    sendMessage: (message: any) => mouseHoverOnTree.next(message),
    clearMessage: () => mouseHoverOnTree.next(),
    getMessage: () => mouseHoverOnTree.asObservable(),
}